import * as React from 'react';
import { ProductStakeType, CouponStakeType, IMoneyWithCurrency, TicketMaxStakeVisibility } from 'eTip--common';
import { NumberInputForStake, PresetStakes } from 'common--design-library';
import { translation, numberFormatter, currencyFormatter, currency, pointsCurrency } from 'easit--localization';
import classNames from 'classnames';

export interface ISummaryProps {
    isSystem: boolean;
    rate: number;
    stake: number;
    stakeMoneyForInfo: number | null;
    stakeWhole?: number;
    useDecimalPlacesForStake: boolean;
    pricePotencial: number;
    stakesFix: any[];
    maxStake?: number;
    rateChangeOptions?: React.ReactNode;
    areRatesUpToDate: boolean;
    isEnabledUI: boolean;
    isModifyOddsInProgress: boolean;
    productStakeType?: ProductStakeType;
    couponStakeType: CouponStakeType;
    isSummaryValid: boolean;
    currency: string;
    canShowStakeWhole: boolean;
    canShowStakeForBet: boolean;
    canShowStakeForCoupon: boolean;
    canShowAverageRate: boolean;
    productFee: IMoneyWithCurrency;
    oddsRateAdvantage: number;
    rateAdvantageFactor: number;
    handlingFeeValue?: number;
    handlingFeePointsValue?: number;
    isFreeTicketAccountTypeSelected: boolean;

    setStake: (isValid: boolean, value?: number) => void; // probably implemented by ()=>Promise<void>
    stakeChanged: () => void;
    ticketMaxStakeVisibility: TicketMaxStakeVisibility;
}
//used for desktop too
export const Summary: React.FC<ISummaryProps> = (props) => {

    const { maxStake, rate, pricePotencial, stakesFix, isEnabledUI, handlingFeeValue, handlingFeePointsValue, ticketMaxStakeVisibility, isFreeTicketAccountTypeSelected } = props;

    const renderPotentialPrice = () => {
        return <div className="ticket-summary-item d-flex justify-content-between">
            <span className="label-text">{translation().coupon_SummaryPricePotential}</span>
            <span className={__IsMTSTipos__ ? "fake-input" : null}>
                <span className="value mr-1">
                    {props.isModifyOddsInProgress && <span className="fas fa-spinner fa-spin mr-3"></span>}
                    {props.isSummaryValid ? currencyFormatter.formatWithoutCurrency(pricePotencial) : '-'}</span>
                <span className={__IsMTSTipos__ ? null : "currency-placeholder"}>{currency}</span>
            </span>
        </div>
    }

    const renderValueRow = (title: string, formattedValue: string, currency: string) => {
        return <div className="ticket-summary-item d-flex justify-content-between">
            <span className="label-text">{title}</span>
            <span className={__IsMTSTipos__ ? "fake-input" : null}>
                <span className="value mr-1">
                    {formattedValue}</span>
                <span className={__IsMTSTipos__ ? null : "currency-placeholder"}>{currency}</span>
            </span>
        </div>
    }

    const renderRateAdvantageValues = () => {
        return props.isSummaryValid && <>
            {props.productFee && renderValueRow(translation().bet_ProductFee, currencyFormatter.formatWithoutCurrency(props.productFee.amount), props.productFee.currency)}
            {props.oddsRateAdvantage > 0 && renderValueRow(translation().bet_OddsRateAdvantage, numberFormatter.format(props.oddsRateAdvantage), "")}
            {props.rateAdvantageFactor > 0 && renderValueRow(translation().bet_RateAdvantageFactor, numberFormatter.format(props.rateAdvantageFactor), "")}
        </>
    }

    const renderRateChange = () => {
        return props.rateChangeOptions && <div className={"rate-change-toggles"}>{props.rateChangeOptions}</div>;
    }

    const t = translation();

    return <div className="ticket-summary">
        {!props.isSystem &&
            <React.Fragment>
                <div className="ticket-summary-item stake d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center">
                        <span className="label-text">{t.coupon_Stake}:
                            {maxStake > 0 && ticketMaxStakeVisibility === TicketMaxStakeVisibility.InStakeLabel && ` (${t.coupon_MaxStake} ${currencyFormatter.format(maxStake)})`}
                        </span>
                        <div className={__IsMTSTipos__ ? "stake-input-wrapper" : null}>
                            <NumberInputForStake
                                className={classNames("ml-1 stake-input", __IsMTSTipos__ ? "text-center" : "text-right mr-1")}
                                value={props.stake}
                                canUseDecimals={props.useDecimalPlacesForStake}
                                onChange={(isValid, value) => { if (props.isEnabledUI) { props.setStake(isValid, value); } }}
                                onBlur={() => { isEnabledUI && props.stakeChanged(); }}
                                disabled={!isEnabledUI || isFreeTicketAccountTypeSelected}
                                roleForTest={"summary__total-stake"}
                            />
                            <span className={__IsMTSTipos__ ? null : "currency-placeholder"}>{props.currency}</span>
                        </div>
                    </div>
                    {ticketMaxStakeVisibility === TicketMaxStakeVisibility.NewLine &&
                        <div className="d-flex justify-content-between align-items-center">
                            <span className="label-text">{`${t.coupon_MaxStake}: `}</span>
                            <div>
                                <span className="value mr-1">{maxStake > 0 ? numberFormatter.format(maxStake) : "-"}</span>
                                <span className="currency-placeholder">{props.currency}</span>
                            </div>
                        </div>
                    }
                </div>
                {
                    props.stakeMoneyForInfo > 0 && <div className="ticket-summary-item stake d-flex justify-content-between align-items-center">
                        <span className="label-text"></span>
                        <div>
                            <span className="value mr-1">{currencyFormatter.formatWithoutCurrency(props.stakeMoneyForInfo)}</span>
                            <span className="currency-placeholder">{currency}</span>
                        </div>
                    </div>
                }
                <PresetStakes presetStakes={stakesFix} //TODO_FT: pridat class disabled, kdyz je vybrany FT
                    isEnabledUI={props.isEnabledUI}
                    maxStake={maxStake}
                    setStake={(stake) => { props.setStake(true, stake) }}
                    onStakeChaned={props.stakeChanged}
                    isFreeTicketAccountTypeSelected={isFreeTicketAccountTypeSelected}
                />

                {
                    (props.isSummaryValid && (handlingFeeValue > 0 || handlingFeePointsValue > 0)) &&
                    <div className="ticket-summary-item d-flex justify-content-between">
                        <span className="label-text">{t.bet_HandlingFee}</span>
                        <span>
                            {
                                handlingFeeValue > 0 &&
                                <span className="value">{numberFormatter.format(handlingFeeValue)} <span className="currency-placeholder">{currency}</span></span>
                            }
                            {
                                (handlingFeeValue > 0 && handlingFeePointsValue > 0) &&
                                <span> / </span>
                            }
                            {
                                handlingFeePointsValue > 0 &&
                                <span className="value">{numberFormatter.format(handlingFeePointsValue)} <span className="currency-placeholder">{pointsCurrency}</span></span>
                            }
                        </span>
                    </div>
                }
                <div className="ticket-summary-item d-flex justify-content-between">
                    <span className="label-text">{t.coupon_TotalRate}</span>
                    <span className={__IsMTSTipos__ ? "fake-input" : "value"}>
                        {__IsMTSTipos__ ?
                            <span className="value" data-test-role="total-rate">{numberFormatter.format(rate)}</span>
                            :
                            <>
                                {numberFormatter.format(rate)}
                                <span className="currency-placeholder"></span>
                            </>
                        }
                    </span>
                </div>
                {renderPotentialPrice()}
                {renderRateAdvantageValues()}
                {renderRateChange()}
            </React.Fragment>
        }
        {
            props.isSystem &&
            <React.Fragment>
                {
                    props.canShowStakeForCoupon &&
                    <div className="ticket-summary-item stake d-flex justify-content-between align-items-center">
                        <span className="label-text">{t.coupon_Stake}: {/*maxStake > 0 && <>({t.coupon_MaxStake} {currencyFormatter.format(maxStake))</> what about points? }*/}</span>
                        <div>
                            <NumberInputForStake
                                className={classNames("ml-1 stake-input", __IsMTSTipos__ ? "text-center" : "text-right mr-1")}
                                value={props.stake}
                                canUseDecimals={props.useDecimalPlacesForStake}
                                onChange={(isValid, value) => { if (props.isEnabledUI) { props.setStake(isValid, value); } }}
                                onBlur={() => { isEnabledUI && props.stakeChanged(); }}
                                disabled={!isEnabledUI}
                                roleForTest="summary__total-stake"
                            />
                            <span className={__IsMTSTipos__ ? null : "currency-placeholder"}>{props.currency}</span>
                        </div>
                    </div>
                }
                {(props.canShowStakeWhole || props.canShowStakeForBet) &&
                    <div className="ticket-summary-item stake d-flex justify-content-between align-items-center">
                        <span className="label-text">{t.coupon_StakeForOneTicketInSystem}:</span>
                        <div>
                            {
                                props.canShowStakeForBet &&
                                <NumberInputForStake
                                    className={classNames("ml-1 stake-input mr-1", __IsMTSTipos__ ? "text-center" : "text-right")}
                                    value={props.stake}
                                    canUseDecimals={props.useDecimalPlacesForStake}
                                    onChange={(isValid, value) => { if (props.isEnabledUI) { props.setStake(isValid, value); } }}
                                    onBlur={() => { isEnabledUI && props.stakeChanged(); }}
                                    disabled={!isEnabledUI}
                                    roleForTest="summary__stake-for-one-bet"
                                />
                            }
                            {
                                props.canShowStakeWhole &&
                                    __IsMTSTipos__
                                    ?
                                    <>
                                        <span className="fake-input">
                                            <span className="value mr-1" data-test-role="summary__stake-for-one-bet">{props.isSummaryValid ? currencyFormatter.formatWithoutCurrency(props.stakeWhole) : '-'}</span>
                                            <span>{props.currency}</span>
                                        </span>
                                        {/* <span>{props.currency}</span> */}
                                    </>
                                    : <>
                                        <span className="value mr-1" data-test-role="summary__stake-for-one-bet">{props.isSummaryValid ? currencyFormatter.formatWithoutCurrency(props.stakeWhole) : '-'}</span>
                                    </>
                            }
                            {!__IsMTSTipos__ && <span className="currency-placeholder">{props.currency}</span>}
                        </div>
                    </div>
                }
                {
                    props.canShowAverageRate &&
                    <div className="ticket-summary-item d-flex justify-content-between">
                        <span className="label-text">{t.coupon_AverageRate}</span>
                        {__IsMTSTipos__
                            ?
                            <span className="fake-input">
                                <span className="value">
                                    {props.isModifyOddsInProgress && <span className="fas fa-spinner fa-spin mr-3"></span>}
                                    {props.isSummaryValid ? numberFormatter.format(props.rate) : '-'}</span>
                            </span>
                            :
                            <span>
                                <span className="value mr-1">
                                    {props.isModifyOddsInProgress && <span className="fas fa-spinner fa-spin mr-3"></span>}
                                    {props.isSummaryValid ? numberFormatter.format(props.rate) : '-'}</span>
                                <span className="currency-placeholder"></span>
                            </span>
                        }
                    </div>
                }
                {renderPotentialPrice()}
                {renderRateAdvantageValues()}
                {renderRateChange()}
            </React.Fragment>
        }
    </div>
}
